import { useQuery } from 'react-query';

import { queryOptions } from '@domains/pdp-common';

import { getPdpInfiniteRecommendGroupByProductIdList } from '../graphql/pdp_infinite_recommend_group_by_product_id_list.2';
import { GetPdpInfiniteRecommendGroupByProductIdListVariables } from '../graphql/pdp_infinite_recommend_group_by_product_id_list_types.2';

const QUERY_KEY = 'getPdpInfiniteRecommendGroupByProductIdList';

const fetchPdpInfiniteRecommendGroupByProductIdList = async (
  params: GetPdpInfiniteRecommendGroupByProductIdListVariables,
) => {
  const {
    data: { pdp_infinite_recommend_group_by_product_id_list },
  } = await getPdpInfiniteRecommendGroupByProductIdList(params, { show_alert: false });
  return pdp_infinite_recommend_group_by_product_id_list;
};

interface Props extends GetPdpInfiniteRecommendGroupByProductIdListVariables {
  enabled: boolean;
}
export const usePdpInfiniteRecommendGroupByProductIdList = (params: Props) => {
  return useQuery({
    queryKey: [QUERY_KEY, ...params.id_list, params.group_type],
    queryFn: () =>
      fetchPdpInfiniteRecommendGroupByProductIdList({ id_list: params.id_list, group_type: params.group_type }),
    enabled: params.enabled && Boolean(params.id_list.length),
    ...queryOptions,
  });
};
